import { render } from "./TextBox.vue?vue&type=template&id=a068dedc&scoped=true&ts=true"
import script from "./TextBox.vue?vue&type=script&lang=ts"
export * from "./TextBox.vue?vue&type=script&lang=ts"

import "./TextBox.vue?vue&type=style&index=0&id=a068dedc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a068dedc"]])

export default __exports__